import React from 'react';
import { Routes as RrdRoutes, Route, BrowserRouter } from 'react-router-dom';

import Home from './pages/Home';
import Scan from './pages/Scan';

const Routes = (props) => {
    return (
        <RrdRoutes>
            <Route exact path='/' element={<Home />} />
            <Route exact path='/scan' element={<Scan />} />
        </RrdRoutes>
    );
};

export default Routes;
